import { message, Radio, Alert, Checkbox } from "antd";
import axios from "axios";
import React, { Component } from "react";
import { connect } from "react-redux";
import {
  Form,
  ModalItem,
  FormItem,
  InputNumberItem,
  TextAreaItem,
  DatePickerItem,
  ButtonItem,
  ErrorItem,
  NotificacionPolizas,
  dineroDisabledMask,
} from "../../../../Components/Items";

class AumentarCredito extends Component {
  formRef = React.createRef();
  state = {
    loading: false,
    contablemente: true,
    confirmoRevision: false,
  };

  cerrarAumentarCredito() {
    this.setState({ contablemente: true, confirmoRevision: false });
    this.props.cerrarAumentarCredito();
  }

  onFinishFailed(e) {
    ErrorItem(e);
  }

  onFinish(values) {
    if (!this.state.contablemente && !this.state.confirmoRevision) {
      message.error(
        "Confirma que revisaste que la contabilidad ya está correcta"
      );
      return;
    }

    this.setState({ loading: true });
    axios
      .post(
        "creditos/aumentarCredito",
        {
          ...values,
          contablemente: this.state.contablemente,
          creditoId: this.props.credito?._id,
          empresaId: this.props.empresaId,
        },
        { headers: this.props.headersToken }
      )
      .then((res) => {
        this.setState({ loading: false });
        if (res.data.success === 2) {
          message.success("Se aumentó el crédito");
          if (res.data.polizasId?.length) {
            NotificacionPolizas(res.data.polizasId);
          }
          this.formRef.current.resetFields();
          this.cerrarAumentarCredito();
        } else {
          message.error(res.data.message || "Sucedió un error y no se guardó");
        }
      });
  }

  render() {
    const credito = this.props.credito;

    //El aumento hereda la modalidad del credito: genera otro abono al proveedor
    //y por eso no puede ir sin poliza
    const abonoProveedor = credito?.abonoProveedor === true;

    return (
      <ModalItem
        title="Aumentar Crédito"
        visible={this.props.visible}
        spinning={this.state.loading}
        onCancel={this.cerrarAumentarCredito.bind(this)}
      >
        {credito && (
          <div style={{ marginBottom: 12 }}>
            <div>
              <b>Crédito:</b> {credito.nombre}
            </div>
            <div>
              <b>Total actual:</b> {dineroDisabledMask(credito.totalCredito)}
            </div>
            <div>
              <b>Saldo actual:</b> {dineroDisabledMask(credito.saldo)}
            </div>
          </div>
        )}
        <Form
          ref={this.formRef}
          name="aumentarCredito"
          layout
          bottom={
            <ButtonItem
              type="primary"
              htmlType="submit"
              style={{ display: "block", margin: "0 0 0 auto" }}
            >
              Aumentar
            </ButtonItem>
          }
          onFinish={this.onFinish.bind(this)}
          onFinishFailed={this.onFinishFailed}
        >
          <FormItem name="monto" label="Monto a Aumentar" required number margin>
            <InputNumberItem dinero placeholder="Monto a Aumentar" />
          </FormItem>

          {abonoProveedor && (
            <Alert
              type="info"
              showIcon
              message="Este aumento generará un abono adicional al proveedor."
              description="El cargo va a su cuenta de anticipos y el abono queda disponible para aplicarse a sus facturas desde Cuentas Por Pagar. Por eso el aumento tiene que generar póliza."
              style={{ marginBottom: 12 }}
            />
          )}

          <FormItem label="¿También aumentar contablemente?" margin>
            <Radio.Group
              value={this.state.contablemente}
              onChange={(e) =>
                this.setState({
                  contablemente: e.target.value,
                  confirmoRevision: false,
                })
              }
            >
              <Radio value={true}>Sí, crear póliza contable</Radio>
              <Radio value={false} disabled={abonoProveedor}>
                No, la contabilidad ya está registrada
              </Radio>
            </Radio.Group>
          </FormItem>

          {this.state.contablemente ? (
            <>
              <FormItem name="fechaRegistro" label="Fecha" margin>
                <DatePickerItem placeholder="Fecha" allowClear={false} />
              </FormItem>
              <FormItem name="concepto" label="Concepto" margin pattern>
                <TextAreaItem placeholder="Aumento de crédito" />
              </FormItem>
            </>
          ) : (
            <div style={{ marginBottom: 12 }}>
              <Alert
                type="warning"
                showIcon
                message="Vas a aumentar el monto del crédito sin generar una póliza."
                description="Verifica que la contabilidad ya refleje este aumento correctamente antes de continuar."
                style={{ marginBottom: 8 }}
              />
              <Checkbox
                checked={this.state.confirmoRevision}
                onChange={(e) =>
                  this.setState({ confirmoRevision: e.target.checked })
                }
              >
                Confirmo que revisé que la contabilidad está correcta
              </Checkbox>
            </div>
          )}
        </Form>
      </ModalItem>
    );
  }
}

const mapStateToProps = (state) => {
  return {
    headersToken: state.user.headersToken,
    empresaId: state.empresa.id,
  };
};

export default connect(mapStateToProps)(AumentarCredito);
